import {useState, useLayoutEffect} from "react";
import {getZIndex} from "@cdx/ds/utils/dom-utils";

export const useZIndex = (node: HTMLElement | null | undefined) => {
  const [zIndex, setZIndex] = useState(node ? 5 : null);
  useLayoutEffect(() => {
    if (node) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setZIndex(getZIndex(node) ?? null);
    } else {
      setZIndex(null);
    }
  }, [node, setZIndex]);
  return zIndex;
};
